export default __webpack_public_path__ + "static/Muli-Regular-d08337b78196eb4754a075bbea829ee1.ttf";